import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';
import { donationTypeExtraction } from '../../../libs/services';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');

class GroupStats extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);
		this.getDonationsType = this.getDonationsType.bind(this);
		this.getConvokePlace = this.getConvokePlace.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],

			extraction_type_id:"all",
			extraction_type:[],

			donation_type_id:"all",
			donations_type:[],

			start_date 	:"",
			end_date 	:"",
			
			convoke_places:[],
			convoke_places_id:"all",

			listado:[],

			change_check: false,
			columns:[
				{title:'TIPO DONACIÓN'},
				{title:'TIPO EXTRACCIÓN'},
				{title:'O+'},
				{title:'O-'},
				{title:'A+'},
				{title:'A-'},
				{title:'B+'},
				{title:'B-'},
				{title:'AB+'},
				{title:'AB-'},
				{title:'TOTAL'},
			],
			rhGroup:[],
			rh_group:"all",
			totales:[],
			option:"",

			extraction_type_name:"",
			donation_type_name:"",
			convoke_places_name:"",
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	async componentDidMount(){
		this.props.waiting.handleShow('Cargando...');


		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		this.getConvokePlace();

		let aux_resp = await donationTypeExtraction("no_cells");
        if(aux_resp !== undefined){
            this.setState({
                extraction_type: aux_resp
            });
        }

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.getDonationsType();
		this.props.waiting.handleClose();
		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			order: [[1, 'asc']],
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: "Estadística de Grupo"
            	},
            	{
                	extend: 'pdfHtml5',
                	exportOptions:{
                		columns: ':visible'
                	},
                	title: "Estadística de Grupo",
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] })

						doc.content.splice(3, 0, {
							columns:[
								this.state.convoke_places_id !== "all" ?
									{text: 'Lugar de Colecta', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.convoke_places_id !== "all" ?
									{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.extraction_type_id !== "all" ?
									{text: 'Extracción', width:'8%', fontSize:6.5}
								: {text:"", width:0},
								this.state.extraction_type_id !== "all" ?
									{text: this.state.extraction_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
								: {text:"", width:0},

								this.state.donation_type_id !== "all" ?
									{text: 'Donación', width:'8%', fontSize:6.5}
								: {text:"", width:0},
								this.state.donation_type_id !== "all" ?
									{text: this.state.donation_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
								: {text:"", width:0}

							]
						});

                		doc.defaultStyle.fontSize = 9;
                		doc.styles.tableHeader.fontSize = 9;            		

                		doc.content[4].table.body.map((b, i)=>{
                			b.map((t, j)=>{
                				if(this.state.option === 'by_center'){
                					if(j > 0){
	                					b[j].alignment = 'center' 
	                				}
                				}else{
                					if(j > 1){
	                					b[j].alignment = 'right' 
	                				}
                				}
                				         				
                			})
                		});

                		if(this.state.option === 'by_center'){
            				doc.content[4].table.widths=["53%","5%","5%","5%","5%","5%","5%","5%","5%","7%"];
            			}else{
            				doc.content[4].table.widths=["26.5%","26.5%","5%","5%","5%","5%","5%","5%","5%","5%","7%"];
            			}

            			doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};

                	} 
            	},
            ],
            columnDefs: [{
		        targets: this.state.option === 'by_center' ? [1,2,3,4,5,6,7,8,9] : [2,3,4,5,6,7,8,9,10],
		        className: 'dt-right'
    		}],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			ordering:true,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			createdRow: function(row, data, dataIndex){
				if(data[1] === 'TOTAL' || data[0] === 'TOTAL'){
					$('td', row).each(function(){
			            $(this).html( '<b>'+$(this).text()+'</b>' );
			        });
				}else if(data[data.length - 1] !== ""){
                	$('td:eq('+(data.length - 1)+')', row).attr('style', 'font-weight: bold;');
                }

				return row;
            }
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
				//this.getLabSection();
				//this.getWorkSession();
			}, 500);
				
		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'extraction_type_id'){
			this.setState({
				extraction_type_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'donation_type_id'){
			this.setState({
				donation_type_name: e.target.options[e.target.selectedIndex].text
			})
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					extraction_type_id:this.state.extraction_type_id,
					donation_type_id:this.state.donation_type_id,
					convoke_places_id : this.state.convoke_places_id,
					group:this.state.rh_group === 'all' ? this.state.rh_group : this.state.rh_group.split(' ')[0],
					rh:this.state.rh_group === 'all' ? this.state.rh_group :this.state.rh_group.split(' ')[1],
					option:this.state.option,
					health_facilities_id:this.state.health_facilities_id
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/group_rh_stats',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){

						this.setState({
							listado: [],
							totales:[]
						});


						if(this.state.option === 'by_center'){
							this.setState({
								columns:[
									{title:'CENTRO'},
									{title:'O+'},
									{title:'O-'},
									{title:'A+'},
									{title:'A-'},
									{title:'B+'},
									{title:'B-'},
									{title:'AB+'},
									{title:'AB-'},
									{title:'TOTAL'},
								],
							})
						}else{
							this.setState({
								columns:[
									{title:'TIPO DONACIÓN'},
									{title:'TIPO EXTRACCIÓN'},
									{title:'O+'},
									{title:'O-'},
									{title:'A+'},
									{title:'A-'},
									{title:'B+'},
									{title:'B-'},
									{title:'AB+'},
									{title:'AB-'},
									{title:'TOTAL'},
								],
							})
						}

						
						var list = [];
						response.res.map((r)=>{
							var obj = [];
							if(this.state.option === 'by_center'){
								obj.push(r.center_name);
							}else{
								obj.push(r.donation_type,r.extraction_type,)
								
							}
							
							this.state.columns.map((c, i)=>{
								if(this.state.option === 'by_center'){
									if(i > 0 && i < this.state.columns.length - 1){
										var index = r.groups.findIndex(obj => obj.group === c.title);
								
										if(index !== -1){
											obj.push(r.groups[index].count);
										}else{
											obj.push('');
										}
									}
								}else{
									if(i > 1 && i < this.state.columns.length - 1){
										var index = r.groups.findIndex(obj => obj.group === c.title);
										
										if(index !== -1){
											obj.push(r.groups[index].count);
										}else{
											obj.push('');
										}
									}
									
								}
										
							})
							

							obj.push(r.count);

							list.push(obj);
						});
						
						var total = 0;
						response.total.map((t)=> total += t.num);
						var totales = [];
						if(response.total.length > 0){
							if(this.state.option === 'by_donation'){
								totales.push('');
							}
							totales.push('TOTAL');
							this.state.columns.map((c, i)=>{
								if(this.state.option === 'by_center'){
									if(i > 0 && i < this.state.columns.length - 1){
										var index = response.total.findIndex(obj => obj.text === c.title);

										if(index !== -1){
											totales.push(response.total[index].num);
										}else{
											totales.push('');
										}
									}
								}else{
									if(i > 1 && i < this.state.columns.length - 1){
										var index = response.total.findIndex(obj => obj.text === c.title);

										if(index !== -1){
											totales.push(response.total[index].num);
										}else{
											totales.push('');
										}
									}
								}
										
							})

							totales.push(total)

							list.push(totales);
						}
							
						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							totales:response.total
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

 	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

 	getDonationsType(){
 		fetch(Config.default.apiGateway.URL+'donation_type/actives', {
 			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
 		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					donations_type: response
				});
			}
		});
 	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Laboratorio ->
					{t('sidebar.nav.reports.group_rh_stats')}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_group_stats"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>

								<div className="form-group">
									<span className="span-min">Tipo de Extracción</span>
									<select className="form-control" name="extraction_type_id" id="extraction_type_id"
										value={this.state.extraction_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.extraction_type.map((don, i)=>{
											return <option key={i} value={don.id}>
												{don.donation_type_process}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Donación</span>
									<select className="form-control"  name="donation_type_id" id="donation_type_id"
										value={this.state.donation_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.donations_type.map((d, i)=>{
											return <option key={i} value={d.donation_type.id}>
												{d.lookup_value}
											</option>
										})}
									</select>
								</div>
								
								<div className="form-group">
									<span className="span-min">Tipo</span>
									<select className="form-control"  name="option" id="option"
										value={this.state.option} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="by_donation">POR DONACIÓN</option>
										<option value="by_center">POR HOSPITAL</option>
									</select>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} 
										style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											Estadística de Grupo
										</span>
									</div>
									<div className="col-xs-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>

									<div className="col-xs-12">
										{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== ""?
											<span>
												Lugar de Colecta:  
												<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
											</span>	
										:null}

										{this.state.extraction_type_id !== 'all' && this.state.extraction_type_id !== ""?
											<span style={{marginLeft:"15px"}}>
												Extracción: 
												<b style={{marginLeft:"5px"}}>{this.state.extraction_type_name}</b>
											</span>	
										:null}

										{this.state.donation_type_id !== 'all' && this.state.donation_type_id !== "" ?
											<span style={{marginLeft:"15px"}}>
												Donacion:  
												<b style={{marginLeft:"5px"}}>{this.state.donation_type_name}</b>
											</span>	
										:null}
									</div>
								</div>

									

								<div className="col-xs-12" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								
							</div>

								
						</form>
					</div>
				</div>

			</div>
		)
	}
}

export default translate('translations') (GroupStats);